/**
 * `import.meta.env` is Vite's, and this package deliberately does not pull in vite/client
 * types (it must build under the consumer's config, not its own), so the shape is named
 * inline rather than widened to `any`. Same pattern as useCrudResource's client-search warning.
 */
export const warnInDev = (message: string) => {
  if ((import.meta as { env?: { DEV?: boolean } }).env?.DEV) {
    console.warn(`[crud] ${message}`);
  }
};
